import { styled } from '@linaria/react';

import type { FlexProps } from './types';
import { flexGapMapping } from './types';

export const StyledFlex = styled.div<FlexProps>`
	display: flex;

	&.direction {
		flex-direction: ${({ direction }) => direction || ''};
	}

	&.align {
		align-items: ${({ align }) => align || ''};
	}

	&.justify {
		justify-content: ${({ justify }) => justify || ''};
	}

	&.gap {
		gap: ${({ gap }) => `var(${flexGapMapping[gap!]})`};
	}
`;
